import React, {useId, useState} from 'react';
import PropTypes from 'prop-types';
import {useTranslation} from 'react-i18next';
import InputField from '../form/InputField';
import HyButton from '../utilities/HyButton';
import {ReactComponent as DeleteIcon} from '../utilities/icons/trash.svg';
import '../form/RecordSubtitleFile.css';
import './RecordSubtitleFiles.css';

const languages = ['fi', 'sv', 'en'];

const RecordChapters = ({chapters = {}, onChange, message, disabled = false, refresh = 0}) => {
    const {t} = useTranslation();
    const id = useId();
    const [inputResets, setInputResets] = useState({});

    const change = (language, file) => {
        onChange({...chapters, [language]: file});
    };

    return (
        <div>
            {languages.map(language => {
                const file = chapters[language];
                return (
                    <div key={language}>
                        <div className="record-subtitle-file">
                            <label htmlFor={`${id}-${language}`}
                                   className="record-subtitle-file-language">{t(`record_subtitle_video_text_track_file_${{
                                fi: 'finnish',
                                sv: 'swedish',
                                en: 'english'
                            }[language]}`)}</label>
                            <div className="record-subtitle-file-margin-block"></div>
                            <div className="record-subtitle-file-input">
                                <InputField
                                    key={`${language}-${refresh}-${inputResets[language] || 0}`}
                                    id={`${id}-${language}`}
                                    type="file"
                                    accept=".vtt,text/vtt"
                                    aria-label={t('choose_file')}
                                    message={message?.content?.[language] ? {
                                        content: message.content[language],
                                        type: message.type
                                    } : undefined}
                                    disabled={disabled}
                                    onChange={event => {
                                        const selected = event.target.files?.[0];
                                        if (selected) change(language, selected);
                                    }}
                                />
                            </div>
                            <div className="record-subtitle-file-margin-block"></div>
                            <HyButton type="button" variant="danger" mini leftIcon={<DeleteIcon/>}
                                      aria-label={t('record_chapters_remove')}
                                      disabled={disabled || !file}
                                      onClick={() => {
                                          const {[language]: _removed, ...remainingChapters} = chapters;
                                          onChange(Object.keys(remainingChapters).length > 0 ? remainingChapters : undefined);
                                          setInputResets(resets => ({
                                              ...resets,
                                              [language]: (resets[language] || 0) + 1
                                          }));
                                      }}>
                                <span>{t('record_chapters_remove')}</span>
                            </HyButton>
                        </div>
                        {!message?.content?.[language] && <div className="record-subtitle-files-margin-block"></div>}
                    </div>
                );
            })}
        </div>
    );
};

RecordChapters.propTypes = {
    chapters: PropTypes.object,
    onChange: PropTypes.func.isRequired,
    message: PropTypes.shape({content: PropTypes.object, type: PropTypes.oneOf(['light', 'neutral', 'warning'])}),
    disabled: PropTypes.bool,
    refresh: PropTypes.number
};

export default RecordChapters;
